exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-header[data-v-5f574518]{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between}.modal-close[data-v-5f574518]{cursor:pointer}@media (max-width: 400px){.modal-content[data-v-5f574518]{padding-left:20px;padding-right:20px}}\n", ""]);

// exports
